export const post = {
  slug: "exo-business-systems",
  title: "Business Systems",
  contentType: "article",
  excerpt:
    "ExoHaven business systems – Documenting your SOPs, policies, procedures, and processes.",
  categories: ["exoHaven", "Founder Logs", "Ethos"],
  tags: ["exoHaven", "exoWorld", "resilience", "community", "ethos"],
  author: {
    name: "E. x .O. Team",
    email: "team@exohaven.online",
  },
  publishedAt: "2026-01-23",
  status: "published",
  isTemplate: false,
  featuredImage: "",
  content: `
  ### Business Systems

  Over the last year, I've been struggling.
  Trying to run multiple businesses, 
  overlapping roles, tasks, timelines, and expectations...
  It's honestly enough to drive a girl up the wall. 

  So, to simplify things, 
  let's take a page from well known business terminology, 
  and think about the systems we've built, 
  to start coming into clarity, today.

  ## Freestyle
  When I first started out in voice acting, it was fairly simple.
  I'd do live entertainment over the phone, so it wasn't too complicated.
  Sort of like - pick up the phone, talk a bit, close the sale. 
  That went well, but I wanted to scale. 
  
  I started creating digital files and selling those, and they did okay,
  but the scale wasn't there. Maybe I didn't know how to market myself,
  or maybe my product wasn't as entertaining as I thought... 
  
  I decided to try to create a system that I could sell, 
  so others could try the process out, 
  but quickly I realized a few flaws to that,
  mainly being a lack of income to sustain myself while building.
  I ended up starting a second job to make up the difference.


  ## The Mega-SOP

  Over the year that followed, I started building exoPersona.
  The goal was to weave these two businesses together,
  by having each document I needed linked to the task on my calendar.
  The main goal was to have a place to store my procedures.
  Before the app, 
  Those procedures were all laid out in a single document. 

  Each week was simple enough, get home, laundry, cook, 
  go to work for the weekend, if interrupted, switch to the other job.
  Simple enough, but a single source of truth,
  other than Google Docs - would have made a world of a difference. 
  I hustled for hours, weeks, and months to build exoPersona, 
  but something wasn't adding up.  
 

  ## Cue Third business
  As I started my third business vertical - video production,
  I realized one critical mistake...
  I was literally at the end of my rope.
  No joke. 
  
  I learned this the hard way after a fire on my block,
  just a few weeks after a critical error caused by pushing myself too hard, 
  and as I sat in the house that almost went up in smoke, 
  I realized how vulnerable we - and our systems truly are. 

  I understood on a deep level that something had to change.

  ## The realization
  It took a few months, 
  but I started building exoHaven out of the wreckage. 
  The primary goal was simple - a dashboard for work, 
  and a blog to track my process. 
  
  That's it. 
  A blog, and dashboard model, 
  I could whitelabel and use across my verticals.

  That still didn't fix the biggest issue,
  The Mega-SOP. 

  When I came up with the D-N Narrative Framework,
  it worked for my cookie cutter weeks, 
  as well as for travel. I didn't realize that in business,
  there's a name for this. 

  I'd pretty much re-invented the SOP, procedure, and process
  from pure need. 
  Not well, but it was a foundation to build off of, 
  and as a single person business, it was enough for then. 



---
  ## Breakdown
 
  
  ## **Policy** (Governance Layer)
  - The rules 
    - Internal FAQs for your business employees & managers
    - Rules and expectations
    - Ex: Email response times, work hours, team behaviour 
  
  ## SOP (Standard Operating Procedure - Macro)
  - Large Scope
  - The **playbook** for the business. 
  - Day-by-day, month by month, annually. 
  - Includes: policies, processes, and procedures 
  - Example: “Launch a YouTube Series” SOP → covers ideation, filming, editing, posting, and marketing.
  
  - Metaphor: A full 4-Course Meal cookbook, complete with plating, serving, ingredient ordering, allergy plans, fire protocols. 

  ## **Process** (Meso)
  - The overall *workflow*
  - connects multiple procedures into a larger engine
  - ex: Content Production Workflow - (From draft to publish)
  
  - Metaphor: A full recipe, start to finish, including prep instructions, and cook times - with steps (procedures)

  ## **Procedure** (micro)
  - Task specific checklists or instructions 
  - (ex: The steps for splicing a shoot together)
  - Like: A single step in a recipe


---
Here's a helpful chart for quick reference: 

| Layer       | Scope     | Example                                     | Metaphor                         |
|-------------|-----------|---------------------------------------------|----------------------------------|
| Policy      | Governance| Team conduct, hours, boundaries             | House rules                      |
| SOP         | Macro     | Launch a YouTube series                     | Full-course cookbook             |
| Process     | Meso      | Content production workflow                 | Recipe                           |
| Procedure   | Micro     | Splice a video                              | Single recipe step               |



  --- 
  

  So now with this laid out, it's much easier. 
  I need to simplify and silo each business and focus on what Processes move things forward,
  not spread myself so thin I break, 
  or chase what makes me feel good. 

  I also need to make sure I am not biting off more than I can chew. 
  If a process is too much for a given week, for multiple weeks,
  I need to simplify or eliminate.

  The focus right now is on monthly recurring revenue, 
  so I should focus on using exoHaven (and Google Docs or Notion) to outline my processes,
  and then create procedures when needed. 
  Those need to be added to an SOP for that vertical, market segment, or product,
  with the goal being simplicity over verbosity.  

  Because sustainability isn't about saying yes to everything —  
  it's about saying **yes to the right things**.

  - Ember Desire

> 💡 Want to start your own SOP system?
  > Subscribe to our free newsletter for your [SOP Starter Kit](https://exohaven.online/subscribe?=sop-kit) when it becomes available...
  > or check out how [exoHaven](https://exoHaven.online/dashboard) can help streamline your process today.


### Resources
- [SOP vs. Policy vs. Procedure vs. Process - Waybook](https://www.youtube.com/watch?v=ehFq8-qLrBQ)
Thanks to [Waybook](https://www.waybook.com) for the insights!  


`.trim(),
};

export default post;
